export enum EuroBonusAccountErrorType {
  MISSING = 'euro-bonus-account-missing',
  NOT_ACTIVE = 'euro-bonus-account-not-active',
  NOT_OF_TYPE_EURO_BONUS = 'euro-bonus-account-not-of-type',
  REDEMPTION_DISABLED = 'euro-bonus-account-redemption-disabled',
  INVALID_FIELDS = 'euro-bonus-account-invalid-fields',
  PSG_DID_NOT_MATCH = 'euro-bonus-account-psg-did-not-match',
}
